module.exports = __webpack_public_path__ + "static/media/profile-style-img2.23851539.png";